module.exports = __webpack_public_path__ + "img/volume_off-24px.0d2de471.svg";